export default __webpack_public_path__ + "static/accountHero-3d29a88c6a252b3badb8d268a604a5a5.png";